import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../services/auth.service";
export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: "",
      userReady: false,
      currentUser: { username: "" }
    };
  }
  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) this.setState({ redirect: "/login" });
    this.setState({ currentUser: currentUser, userReady: true })
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    const { currentUser } = this.state;
    return (

      <div className="col-md-12">
        {(this.state.userReady) &&
        <div>
        <header className="jumbotron">
          <h3>
            <strong>Login : {currentUser.username}</strong>
            <div>
              <a className="btn-ohm btn btn-primary" href="/new/password/&id=changepwd">
                <span>Changer mon mot de passe</span>
              </a>
            </div>
          </h3>
        </header>
          <div className="App">
        <p>
          <strong>Email :</strong>{" "}
          {currentUser.useremail}
        </p>
        <strong>Role : </strong>

          {currentUser.roles &&
            currentUser.roles.map((role, index) => <span key={index}>{role==="ROLE_CUSTOMER" ? "Client" : (role==="ROLE_ADMIN" ? "Admin" : (role==="ROLE_SUPER_AGENT" ?  "Superviseur agent interne" : "Agent interne")) }</span>)
          }

      </div>
      </div>
        }
      </div>

    );
  }
}
